import * as Select from '@radix-ui/react-select'
import { Ref, forwardRef } from 'react'

import { cn } from '@/libs/tw'

import SvgIcon from '../svg-icon/svgIcon'
import { Typography } from '../typography/typography'

type DropdownProps = {
	placeholder?: string
	value?: string
	options: {
		value: string | undefined
		label: string
	}[]
	inverted?: boolean
	onUpdate: (value: string) => void
}

export const Dropdown = ({ placeholder, options, value, inverted, onUpdate }: DropdownProps) => {
	return (
		<Select.Root onValueChange={(value) => onUpdate(value)}>
			<Select.Trigger
				className={cn(
					'flex min-w-[120px] items-center justify-between rounded-32 border px-16 py-10',
					inverted
						? ' bg-dropdown-textColor text-dropdown-accentColor  md:bg-dropdown-accentColor md:text-dropdown-textColor'
						: 'border-dropdown-accentColor text-dropdown-accentColor md:border-dropdown-textColor md:text-dropdown-textColor'
				)}
				data-testid="trigger"
			>
				<Select.Value placeholder={value ?? placeholder ?? 'Bitte wählen'}></Select.Value>
				<SvgIcon
					collectionName="ibe"
					iconName="chevron"
					className="mt-2 h-24 w-24 rotate-180"
				/>
			</Select.Trigger>
			<Select.Content className={cn('shadow-none z-10 w-full')}>
				<Select.Viewport
					className={cn(
						'z-20 flex flex-col gap-16 rounded-8 p-16',
						inverted
							? 'bg-dropdown-textColor text-dropdown-accentColor  md:bg-dropdown-accentColor md:text-dropdown-textColor'
							: 'border-dropdown-accentColor text-dropdown-accentColor md:border-dropdown-textColor md:text-dropdown-textColor'
					)}
				>
					{options.map((option) => (
						<SelectItem key={option.value} value={option.value}>
							<Typography element="span" style="p">
								{option.label}
							</Typography>
						</SelectItem>
					))}
				</Select.Viewport>
			</Select.Content>
		</Select.Root>
	)
}

type SelectItemProps = {
	children: JSX.Element
	value: string | undefined
}

const SelectItem = forwardRef(
	({ children, value }: SelectItemProps, forwardedRef: Ref<HTMLDivElement> | undefined) => (
		<Select.Item
			className={cn('flex cursor-pointer justify-between')}
			value={value ?? ''}
			ref={forwardedRef}
		>
			<Select.ItemText>{children}</Select.ItemText>
			<Select.ItemIndicator className="SelectItemIndicator">
				<SvgIcon collectionName="ibe" iconName="check" className="h-16 w-16" />
			</Select.ItemIndicator>
		</Select.Item>
	)
)
